(ns frontend.view.kpi-reporting.kpi-categories.db
  (:require
   [frontend.db :as db]
   [clojure.string :as string]
   [common.util :as cu]
   [potpuri.core :refer [fn-> fn->>]]
   [common.entity :as entity]
   [frontend.utils :as utils]
   [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :kpi-categories]))
(defonce session (r/cursor db/app-state [:session]))
(defonce entities (r/cursor state [:entities]))

(defonce wizard-state (r/cursor state [:wizard]))
(defonce category (r/cursor wizard-state [:category]))
(defonce first-cycle (r/cursor wizard-state [:first-cycle]))
(defonce first-cycle-entity-atom (r/cursor wizard-state [:first-cycle-entity-atom]))
(defonce confirms (r/cursor wizard-state [:confirms]))

(defonce session-entities (r/cursor db/session [:entities]))
(defonce ordering (r/cursor state [:ordering]))
(defonce kpi-ordering (r/cursor ordering [:quantitative]))
(defonce question-ordering (r/cursor ordering [:qualitative]))
(defonce timer (r/cursor state [:timer]))

(defonce creator-state (r/cursor state [:creator]))
(defonce settings-state (r/cursor state [:settings]))
